import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      version="1.1"
    >
      <path
        d="M20,37.5 C10.335,37.5 2.5,29.665 2.5,20 C2.5,10.335 10.335,2.5 20,2.5 C29.665,2.5 37.5,10.335 37.5,20 C37.5,29.665 29.665,37.5 20,37.5 Z M20,35 C28.2842578,35 35,28.2842578 35,20 C35,11.7157422 28.2842578,5 20,5 C11.7157422,5 5,11.7157422 5,20 C5,28.2842578 11.7157422,35 20,35 Z M25.2542969,22.1287109 L17.2960937,27.0296875 C16.7082812,27.3916797 15.9382812,27.2085937 15.57625,26.6207813 C15.454882,26.4236917 15.390625,26.1967741 15.390625,25.9653125 L15.390625,14.0346875 C15.390625,13.3443359 15.9502734,12.7846875 16.640625,12.7846875 C16.8720866,12.7846875 17.0990042,12.8489445 17.2960937,12.9703125 L25.2542969,17.8712891 C26.4299609,18.5953125 26.7960937,20.1352734 26.0720703,21.3109375 C25.8671433,21.6436991 25.5870585,21.923784 25.2542969,22.1287109 L25.2542969,22.1287109 Z"
        id="形状"
        fill="#FFFFFF"
      />
    </svg>
  )
}
const PlayIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
PlayIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
PlayIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default PlayIcon
